import React from 'react';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './Header.scss';

const EditorExpandButton = ({ theme, editorExpand, toggleExpand }) => {
  const { t } = useTranslation('common');
  const isDarkTheme = theme === 'vs-dark';

  return (
    <div
      className={classNames({
        [styles['expand-btn']]: true,
        [styles['expand-btn-dark']]: isDarkTheme,
      })}
      style={{
        cursor: 'pointer',
        border: 'none',
        background: 'none',
        color: isDarkTheme ? 'white' : '#1890FF',
      }}
      onClick={() => toggleExpand()}
      title={
        editorExpand ? t('editor.restore_editor_tooltip') : t('editor.maximize_editor_tooltip')
      }
    >
      {editorExpand ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
    </div>
  );
};

export default EditorExpandButton;
